export enum MeasurementRoutes {
    Measurement = 'details/:id',
    MeasurementImport = 'import',
    MeasurementList = ''
}

export enum MeasurementsRouteId {
    MeasurementId = 'id'
}
